module.exports = __webpack_public_path__ + "static/img/indexText2.8cf1664.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexText2.png
// module id = 6lfk
// module chunks = 1